export default function ErrorFetch() {
  const query = new URLSearchParams(window.location.search);
  const error = query.get("error") || "Unknown error"  
  return (
    <div>
      <h3>Se ha producido un error inesperado</h3>
      <h4>{error}</h4>
      <em>Inténtalo de nuevo más tarde.</em>
    </div>
  );
}